import React, { useEffect, useState } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { loadStripe } from '@stripe/stripe-js';
import { Grid, Link, Dialog } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Payment } from '@material-ui/icons';

import { getLocalizedContent as l } from '@helpers/languages';
import { PaymentMethodElement } from '@components/PaymentMethodElement/PaymentMethodElement';
import { getConfig } from '@api/api';
import content from './CreditCardPayment.json';
import PaymentErrorModal from '@views/Payments/PaymentErrorModal';
import { PaymentProcessingModal } from '@views/Payments/PaymentProcessingModal';
import { amountToCurrencyString, formatPriceWithCents } from '@utils/currency';
import { PaymentConfirmationModal } from '@views/Payments/PaymentConfirmationModal';
import paymentContent from './Payments.json';

const useStyles = makeStyles(() => ({
  bankTransfer: {
    fontWeight: 500,
  },
  partialAmount: {
    width: '258px',
  },
  title: {
    fontFamily: 'SchnyderSLight',
    textAlign: 'center',
  },
  formHelperText: {
    margin: '0px !important',
  },
  backToPaymentOptions: {
    color: 'var(--Grayscale-Nero, #1B1B1B)',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    fontStretch: 'condensed',
  },
}));

const CreditCardPayment = ({
  amountDue,
  onBackToPaymentOptionsClick,
  orderId,
  basepath,
  user,
  availableReservationLimit = 0,
  selectedAmount = { amount: 0, currency: 'USD' },
  onPaymentSuccess,
}) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [paymentConfig, setPaymentConfig] = useState(null);
  const [paymentError, setPaymentError] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  const classes = useStyles();

  useEffect(() => {
    if (stripePromise) return;
    getConfig(selectedAmount.currency === 'CAD' ? 'CA' : 'US', 'vehicle')
      .then(config => {
        setPaymentConfig({
          ...config.data.data,
          currency: selectedAmount.currency,
        });
        loadStripe(config.data.data.publishableKey)
          .then(stripe => {
            setStripePromise(stripe);
          })
          .catch(err => {
            console.error('Error on get stripe api: ', err);
          });
      })
      .catch(err => {
        console.error('Error on config api: ', err);
      });
  }, []);

  useEffect(() => {
    console.log('paymentDetails', { ...paymentDetails });
  }, [paymentDetails]);

  const handleSuccess = data => {
    setPaymentDetails({
      ...paymentDetails,
      ...data,
      payment_method_type: 'card',
    });
    setPaymentProcessing(false);
    setPaymentSuccess(true);
  };

  const handleProccess = data => {
    setPaymentDetails(data);
    setPaymentProcessing(true);
  };

  const handleCancel = data => {};

  const handleError = (data = '') => {
    setPaymentProcessing(false);
    setPaymentError(data.toString());
  };

  const onChangeMethod = () => {
    setPaymentError(null);
  };

  return (
    stripePromise && (
      <>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h5">
              {l(paymentContent.paySecOnline, language)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Link
              onClick={onBackToPaymentOptionsClick}
              data-back-to-payment-options
              className={classes.backToPaymentOptions}
            >
              {l(content.backToPaymentOptions, language)}
            </Link>
          </Grid>
          <Grid item xl={12}>
            <PaymentMethodElement
              stripe={stripePromise}
              paymentConfig={paymentConfig}
              amount={selectedAmount.amount * 1.03}
              customer={user}
              type={'card'}
              onSuccess={handleSuccess}
              onProccess={handleProccess}
              onCancel={handleCancel}
              onError={handleError}
              orderId={orderId}
              reset={paymentError}
            />
          </Grid>
          {paymentError && (
            <PaymentErrorModal
              onClose={() => setPaymentError(false)}
              open={open}
              errorText={paymentError}
              onChangeMethod={onChangeMethod}
            />
          )}

          {paymentProcessing && (
            <PaymentProcessingModal
              open={paymentProcessing}
              amountChargedString={amountToCurrencyString(
                paymentDetails.amount,
                paymentDetails.currency,
                language
              )}
            />
          )}

          {paymentSuccess && (
            <PaymentConfirmationModal
              open={paymentSuccess}
              onClose={() =>
                window.location.assign(`${basepath}orders/${orderId}/payments`)
              }
              paymentError={paymentError}
              paymentDetails={paymentDetails}
              onTryAgainError={() => {
                setPaymentError(false);
              }}
            />
          )}
        </Grid>
      </>
    )
  );
};

export default CreditCardPayment;
